<template>
  <ul :class="isJobCard ? 'text-sm sm:text-base' : 'text-base'">
    <!-- SECTION -->
    <li v-if="page?.section">
      <Component
        :is="divOrNuxtLink"
        v-bind="
          !isJobCard
            ? {
                to: {
                  path: `/${route.path.split('/')[1]}`,
                  query: { section: JSON.stringify(page.section) },
                },
              }
            : {}
        "
        :class="isWhite ? 'bg-white' : 'bg-[#F5FAFD]'"
        class="flex w-fit rounded-sm px-3 py-[0.625rem]"
      >
        <SuitCaseIcon
          class="text-blue-800"
          :class="isJobCard ? 'w-4 sm:w-[1.125rem] mr-2' : 'w-[1.125rem] mr-3'"
        />
        {{ page?.section?.title }}
      </Component>
    </li>

    <!-- LOCATION -->
    <li v-if="page?.location">
      <Component
        :is="divOrNuxtLink"
        v-bind="
          !isJobCard
            ? {
                to: {
                  path: `/${route.path.split('/')[1]}`,
                  query: { location: JSON.stringify(page.location) },
                },
              }
            : {}
        "
        class="flex w-fit rounded-sm px-3 py-[0.625rem]"
        :class="isWhite ? 'bg-white' : 'bg-[#F5FAFD]'"
      >
        <MarkerIcon
          class="text-blue-800"
          :class="isJobCard ? 'w-3 sm:w-[0.875rem] mr-2' : 'w-[0.875rem] mr-3'"
        />
        {{ page.location?.title }}
      </Component>
    </li>

    <!-- TYPE -->
    <li v-if="page?.type">
      <Component
        :is="divOrNuxtLink"
        v-bind="
          !isJobCard
            ? {
                to: {
                  path: `/${route.path.split('/')[1]}`,
                  query: { type: JSON.stringify(page.type) },
                },
              }
            : {}
        "
        class="flex w-fit rounded-sm px-3 py-[0.625rem]"
        :class="isWhite ? 'bg-white' : 'bg-[#F5FAFD]'"
      >
        <PenIcon
          class="w-4 text-blue-800"
          :class="isJobCard ? 'mr-2' : ' mr-3'"
        />
        {{ page?.type?.title }}
      </Component>
    </li>

    <!-- DATE FROM -->
    <li
      v-if="startOfWork"
      class="flex w-fit rounded-sm px-3 py-[0.625rem]"
      :class="isWhite ? 'bg-white' : 'bg-[#F5FAFD]'"
    >
      <ClockIcon
        class="text-blue-800"
        :class="isJobCard ? 'w-[0.875rem] sm:w-4 mr-2' : 'mr-3 w-4'"
      />
      {{ startOfWork }}
    </li>
  </ul>
</template>

<script setup>
const props = defineProps({
  page: {
    type: Object,
    required: true,
  },

  isWhite: {
    type: Boolean,
    default: false,
  },

  isJobCard: {
    type: Boolean,
    default: false,
  },
})

const route = useRoute()
const { locale, t } = useI18n()

// COMPUTED
const startOfWork = computed(() => {
  if (props.page.start_of_work?.value === 'by_date') {
    let date = new Date(props.page.start_of_work_date)
    date = date.toLocaleDateString(locale.value, {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    })
    return `${t('from')} ${date}`
  }
  return props.page.start_of_work?.label
})

// FUNCTIONS
// determine whether to load NuxtLink or button
const divOrNuxtLink = computed(() => {
  if (!props.isJobCard) {
    return resolveComponent('NuxtLink')
  }

  return 'div'
})
</script>
